import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { redirectToDismissAlert } from '../../../../../routing/redirectService';
import { AlertsTable } from '../../../../../shared/table/AlertsTable';
import TransparentButton from '../../../../../shared/button/transparent-button/TransparentButton';

class HistoryOfAlerts extends Component {
    alertsHeaders = [
        { key: 'DETAIL', value: 'DETAIL', showArrowSort: false },
        { key: 'ALERT_LEVEL', value: 'SEVERITY', showArrowSort: true },
        { key: 'ALERT_TYPE', value: 'ALERT TYPE', showArrowSort: true },
        {
            key: 'RAISED_TIMESTAMP',
            value: 'RAISED TIMESTAMP',
            showArrowSort: true
        },
        { key: 'DISMISSED', value: 'STATUS', showArrowSort: false },
        {
            key: null,
            value: '',
            showArrowSort: false
        } /* This is the actions column. */
    ];

    dismissAlert(alert) {
        redirectToDismissAlert(alert.rule.category, alert);
    }

    render() {
        const {
            alerts,
            pagination,
            loading,
            onPaginationUpdated,
            onSortUpdated,
            filters,
            filtersConfig,
            applyFilters,
            clearFilters,
            removeFilter,
            exportCsvLoading
        } = this.props;
        return (
            <Fragment>
                <div className={'row-space-between'}>
                    <h2>History of Alerts</h2>
                    <TransparentButton
                        disabled={exportCsvLoading || this.props.exportDisabled}
                        onClick={this.props.handleExportCsv}
                    >
                        <i className={'material-icons'}>save</i>
                        {this.props.exportCsvLoading
                            ? 'Exporting...'
                            : 'Download CSV'}
                    </TransparentButton>
                </div>
                <AlertsTable
                    headers={this.alertsHeaders}
                    data={alerts}
                    loading={loading}
                    pagination={pagination}
                    dismissAlert={this.dismissAlert.bind(this)}
                    onPaginationUpdated={onPaginationUpdated}
                    onSortUpdated={onSortUpdated}
                    hideSearch={true}
                    filters={filters}
                    filtersConfig={filtersConfig}
                    applyFilters={applyFilters}
                    clearFilters={clearFilters}
                    removeFilter={removeFilter}
                />
            </Fragment>
        );
    }
}

export default withRouter(HistoryOfAlerts);
